import { performGetRequest } from '../helpers/service'

export const getAppSetting = async () => {
  const response = await performGetRequest('/public-settings')

  return response.data
}
